// discovering feature

// first release date for discovering feature: 2026-05-06

export const FILE_ACCESS_SETTINGS_BUTTON_ID = 'file-access-settings-button';

export const FIRST_RELEASE_DISCOVERING_FEATURE = '2026-05-06';

export const DISCOVERING_FEATURE_VISIBILITY_DAYS = 30;
